import React from 'react'
import Navbar from '../Components/Navbar'
import PanelNavbar from '../Components/PanelNavbar'

const Panel = () => {
  return (
    <div>
      <Navbar />
      <PanelNavbar />
    </div>
  )
}

export default Panel